import { color, compose } from 'styled-system';

import fill from '../customProps/fill';
import webkitTextFillColor from '../customProps/webkitTextFillColor';

export default compose(color, fill, webkitTextFillColor);
